var map = {
	"./action_button_spinner.svg": 498,
	"./active_heart.svg": 499,
	"./active_star.svg": 500,
	"./aperture.svg": 501,
	"./applicant_content.svg": 502,
	"./application.svg": 503,
	"./application_check.svg": 504,
	"./briefcase.svg": 505,
	"./calendar-active.svg": 506,
	"./calendar.svg": 507,
	"./check-circle.svg": 508,
	"./check-square.svg": 509,
	"./dashboard.svg": 510,
	"./diagnostics.svg": 511,
	"./discipline-agriculture.svg": 512,
	"./discipline-applied-sciences.svg": 513,
	"./discipline-arts.svg": 514,
	"./discipline-business.svg": 515,
	"./discipline-education.svg": 516,
	"./discipline-engineering.svg": 517,
	"./discipline-environmental.svg": 518,
	"./discipline-hospitality.svg": 519,
	"./discipline-humanities.svg": 520,
	"./discipline-it.svg": 521,
	"./discipline-journalism.svg": 522,
	"./discipline-law.svg": 523,
	"./discipline-medicine.svg": 524,
	"./discipline-natural-sciences.svg": 525,
	"./discipline-social-sciences.svg": 526,
	"./doc.svg": 527,
	"./download.svg": 528,
	"./edit.svg": 529,
	"./eye.svg": 530,
	"./field_of_study_search.svg": 531,
	"./file.svg": 532,
	"./folder.svg": 533,
	"./harmo.svg": 534,
	"./heart_off.svg": 535,
	"./heart_on.svg": 536,
	"./jpg.svg": 537,
	"./marketplace.svg": 538,
	"./materials.svg": 539,
	"./mentors.svg": 540,
	"./message-square.svg": 541,
	"./monitor.svg": 542,
	"./pdf.svg": 543,
	"./pin.svg": 276,
	"./search.svg": 544,
	"./star_empty.svg": 545,
	"./star_full.svg": 546,
	"./star_off.svg": 547,
	"./star_on.svg": 548,
	"./stripes.svg": 549,
	"./tutors.svg": 550,
	"./upload_icon.svg": 551,
	"./xls.svg": 552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;